import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=fbe432ee&scoped=true&"
import script from "./Document.vue?vue&type=script&lang=js&"
export * from "./Document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe432ee",
  null
  
)

export default component.exports